import { useAllBidsBidDeleted } from './events/allBids/useAllBidsBidDeleted'
import { useAllBidsBidOnAgent } from './events/allBids/useAllBidsBidOnAgent'
import { useAllBidsItemPublish } from './events/allBids/useAllBidsItemPublish'
import { useAllBidsUserBid } from './events/allBids/useAllBidsUserBid'

export const ALL_BIDS_SOCKET_CALLBACK = 'all-bids-update'

export function useAllBidsSocket() {
  const { userBid } = useAllBidsUserBid()
  const { itemPublish } = useAllBidsItemPublish()
  const { bidDeleted } = useAllBidsBidDeleted()
  const { bidOnAgent } = useAllBidsBidOnAgent()

  const init = () => {
    userBid()
    itemPublish()
    bidDeleted()
    bidOnAgent()
  }

  return { init }
}
